import "../../css/service1.css";

function ServiceSection1() {
  return (
    <section className="service1" id="service1">
      <div className="container">
        <div className="row align-items-center">
          {/* Text Column */}
          <div className="col-lg-6 service1-content text-center">
            <h1>Tu puente hacia los mercados internacionales</h1>
            <p>Somos expertos en exportación que te ayudarán a expandir tu negocio globalmente con estrategias personalizadas y soluciones prácticas.</p>
          </div>
          
          {/* Button Column - Now properly centered */}
          <div className="col-lg-6 d-flex justify-content-center align-items-center service1-btn-container">
            <a href="https://wa.me/51924654344?text=Hola Voila Consulting, estoy interesado en sus servicios para un proyecto de exportacion, me podrian detalle de como funciona el proceso" target="_blank" rel="noopener noreferrer" className="btn firstservicebtn">¡Empieza a Exportar Hoy!</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceSection1;